export default "__VITE_ASSET__C$9j2MZw__"